window._ = require('lodash');
import Vue from 'vue/dist/vue.min.js';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    if (process.env.MIX_ENV_MODE === 'production') {
        Vue.config.devtools = false;
        Vue.config.debug = false;
        Vue.config.silent = true;
    }
    //region page preloader
    const vue = new Vue({
        el: '.preloader',
        data: {
            showPreloader: true,
            loaded: 0,
            loading: null,
            loadStyle: {
                top: '0%'
            },
        },
        mounted() {
            if(
                this.$el && document.querySelector(this.el) &&
                window.location.pathname.substring(1).split('/').length === 1 &&
                ['/admin', '/login', '/register', '/password/reset'].indexOf(window.location.pathname) === -1
            ) {
                this.startLoading();
            } else {
                this.showPreloader = false
            }
        },
        watch: {
            loaded() {
                this.loadStyle.top = (100 - this.loaded * .9) + '%'
                if (this.loaded === 100) {
                    this.doneLoading();
                }
            }
        },
        methods: {
            startLoading() {
                document.body.classList.add('overflow-hidden')
                this.$el.classList.remove('d-none')
                document.getElementById('counter').classList.remove('d-none');
                document.getElementById('lemon').classList.remove('d-none');
                document.getElementById('straw').classList.remove('d-none');
                this.loading = setInterval(this.load, 10);
            },
            load() {
                ++this.loaded;
            },
            doneLoading() {
                clearInterval(this.loading);
                this.removePreloader();
            },
            removePreloader() {
                setTimeout(() => {
                    this.showPreloader = false
                }, 200)
                document.body.classList.remove('overflow-hidden')
            },
        }
    })
    //endregion

    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('magnific-popup');

    require('slick-carousel');

    window.Fingerprint2 = require('@fingerprintjs/fingerprintjs');

    window.Dropzone = require('dropzone');
    window.Dropzone.autoDiscover = false;

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
